var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurdoTailCurveWordmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 175",
    role: "img",
    "aria-label": "OURDO Indonesia Tail Curve wordmark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OURDO Indonesia \u2014 Tail Curve wordmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#15263A",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 78,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 37 V89 C161 113 177 126 197 126 C218 126 234 113 234 89 V37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 124 V75 C282 50 297 37 320 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 37 V124 M366 37 H396 C429 37 451 53 451 80 C451 106 429 124 396 124 H366"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 78,
    r: 42
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F36A36",
    d: "M541 136 C558 144 578 144 596 128 C600 125 605 130 601 135 C585 151 559 151 541 136 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurdoTailCurveWordmark);
export default __webpack_public_path__ + "static/media/ourdo-tail-curve-wordmark.be7b32b210324f4689a4d6386c87a86c.svg";
export { ForwardRef as ReactComponent };